import { BaseGameController } from '@/components/game/implementations/_base/_domain/controller/game-controller';
import { injectable, inject } from 'inversify';
import { GameIdentity, GameState } from '@/components/game/_domain/models';
import { NextGameData, CatchUpData, ResetData, ICincoAuthenticationResponse } from '@/components/game/_domain';
import { IServerServiceFactory } from '@/app-modules/server-service';
import { ICincoPrizeElement } from '@/components/game/implementations/uk/cinco/_domain/models';
import { IPrizeStructure, IPrizeElement } from '@/components/game/implementations/_default/_domain/models';
import { IWinnersTrackerService } from '@/components/game/_domain/modules/winners-tracker-service';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IConfigurationService } from '@/app-modules/config';
import { IErrorService } from '@/app-modules/error';

@injectable()
class CincoGameController extends BaseGameController {
  public constructor(
    @inject(SERVICE_IDENTIFIERS.IConfigurationService) configurationService: IConfigurationService,
    @inject(SERVICE_IDENTIFIERS.IServerServiceFactory) serverServiceFactory: IServerServiceFactory,
    @inject(SERVICE_IDENTIFIERS.IWinnersTrackerService) winnersTrackerService: IWinnersTrackerService,
    @inject(SERVICE_IDENTIFIERS.IErrorService) errorService: IErrorService
  ) {
    super(configurationService, serverServiceFactory, winnersTrackerService, errorService);
  }

  public initialise(gameIdentity: GameIdentity) {
    this.game = this.getInitialGame(gameIdentity);
    this.initialiseGameServerConnection();
    this.initialiseGameRetryPolicySettings();
    this.initialiseGameServerService();
  }

  protected subscribeToGameEvents(): void {
    this.serverSubscriptionStore.push(
      this.gameServerService.subscribeCatchUp(this.handleCatchUpMessage.bind(this)),
      this.gameServerService.subscribeWinners(this.handleWinnersMessage.bind(this)),
      this.gameServerService.subscribeReset(this.handleResetMessage.bind(this)),
      this.gameServerService.subscribeCalls(this.handleCallsMessage.bind(this)),
      this.gameServerService.subscribeNextGame(this.handleNextGameMessage.bind(this)),
      this.gameServerService.subscribePrizeWinner(this.handlePrizeWinnerMessage.bind(this))
    );
  }

  protected handleAuthorisationMessage(payload: ICincoAuthenticationResponse): void {
    this.changeGameConnectionState('Authorised');
  }

  protected handleCatchUpMessage(payload: CatchUpData): void {
    this.game.representation.callboard.update(payload.callValues);

    this.changeGameRepresentation({
      gameId: payload.gameNo,
      numberOfPlayers: payload.numberOfPlayers,
      isLinkedGame: payload.isLinkedGame,
      prizeStructure: payload.prizeStructure,
      promoType: payload.promoType,
      promoMultiplier: payload.promoMultiplier
    });
  }

  protected handleNextGameMessage(payload: NextGameData): void {
    this.game.updateRepresentation({
      nextGame: {
        countDownToNextGameInSeconds: payload.time,
        isLinkedGame: payload.isLinkedGame,
        prizeStructure: payload.prizeStructure,
        promoType: payload.promoType
      }
    });

    this.notifyNextGameRepresentationChanged();
  }

  protected handleResetMessage(payload: ResetData): void {

    this.game.representation.callboard.reset();
    this.changeGameState(GameState.InPlay);
    this.changeGameRepresentation({
      gameId: payload.gameId,
      numberOfPlayers: payload.numberOfPlayers,
      nextGame: null,
      isJackpotWon: null,
      prizeStructure: payload.prizeStructure,
      winners: null,
      promoType: payload.promoType,
      promoMultiplier: payload.promoMultiplier
    });
  }


}

export { CincoGameController };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/cinco/_domain/controller/game-controller.ts